var EqState = {
  GOOD: 0,
  AVERAGE: 1,
  BAD: 2,
  NEW: 3,
};

module.exports = EqState;
